export enum ScreenAddressEnum {
  AddressList = 'AddressList',
  NewAddressForm = 'NewAddressForm',
  UpdateAddressForm = 'UpdateAddressForm'
}

export type ScreenAddressType = keyof typeof ScreenAddressEnum;

export interface AddressBaseInterface {
  addr_nickname: string;
  addr1: string;
  addr2: string;
  postal: string;
  city: string;
  state: string;
  is_primary: 0 | 1;
  is_primary_bill: 0 | 1;
  onSuccess: () => void;
}

export interface AddressBaseInterfaceWithId extends AddressBaseInterface {
  addr_id: number;
}
export interface AddressInterface extends AddressBaseInterface {
  state_name: string;
  country_name: string;
  me?: boolean;
}

export interface AddressDataInterface extends AddressInterface {
  addr_id: number;
  addr_phone?: number;
}
